import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "preview", "initials", "modalPreview", "saveButton", "modal"]

  declare readonly inputTarget: HTMLInputElement
  declare readonly previewTarget: HTMLImageElement
  declare readonly initialsTarget: HTMLElement
  declare readonly modalPreviewTarget: HTMLImageElement
  declare readonly saveButtonTarget: HTMLButtonElement
  declare readonly modalTarget: HTMLElement
  declare readonly hasPreviewTarget: boolean
  declare readonly hasInitialsTarget: boolean
  declare readonly hasModalPreviewTarget: boolean
  declare readonly hasSaveButtonTarget: boolean
  declare readonly hasModalTarget: boolean

  connect() {
  }

  openModal(event: Event): void {
    event.preventDefault()
    
    // Attempt to find modal controller efficiently
    const modalElement = this.hasModalTarget ? this.modalTarget : document.getElementById("avatar-modal")

    if (modalElement) {
      // Find the component instance
      const modalController = this.application.getControllerForElementAndIdentifier(
        modalElement.querySelector('[data-controller="shared--ui--modal"]') || modalElement, 
        "shared--ui--modal"
      ) as any
      
      if (modalController && typeof modalController.open === "function") {
        modalController.open()
      }
    }
  }

  triggerInput(event: Event): void {
    event.preventDefault()
    this.inputTarget.click()
  }

  handleFileChange(event: Event): void {
    const input = event.target as HTMLInputElement
    if (input.files && input.files[0]) {
      const reader = new FileReader()
      reader.onload = (e) => {
        const result = e.target?.result as string
        if (result) {
          // Update all preview targets (main and modal)
          const allPreviews = [
            this.hasPreviewTarget ? this.previewTarget : null,
            this.hasModalPreviewTarget ? this.modalPreviewTarget : null
          ].filter(Boolean)

          allPreviews.forEach(target => {
            if (target instanceof HTMLImageElement) {
              target.src = result
              target.classList.remove("hidden")
            }
          })

          if (this.hasInitialsTarget) {
            this.initialsTarget.classList.add("hidden")
          }
        }
      }
      reader.readAsDataURL(input.files[0])
    }
  }

  save(event: Event): void {
    const form = this.inputTarget.form
    if (form) {
      if (!form.checkValidity()) {
        form.reportValidity()
        if (event) event.preventDefault()
        return
      }

      if (this.hasSaveButtonTarget) {
        this.saveButtonTarget.disabled = true
        this.saveButtonTarget.textContent = "..."
      }
      
      // If NOT a submit button that triggered this, manually submit
      const isSubmitButton = (event.currentTarget as HTMLElement)?.getAttribute("type") === "submit"
      if (!isSubmitButton) {
        if (event) event.preventDefault()
        form.requestSubmit()
      }
      
      // We don't close the modal here to let Turbo handle the navigation/replacement
    }
  }
}
